import React from 'react'
import { modal } from '../../core/utilities/modal'

import { user } from '../../core/controllers/user';
import ListingCards from '../../components/Listings/ListingCards';
import { listings } from '../../core/controllers/Listings'
import NavLink from '../../components/Routes/NavLink'

export default class ListingsTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            slug: '',
            listings: null,
        }
    }

    componentDidMount() {
        var self = this;
        user.getCompanySlug(function(response) {
            self.setState({
                slug: response.data
            });
        })
        listings.getListings("0", function(response) {
            self.setState({listings: response.data})
        });
    }

    slugChange(e) {
        this.setState({
            slug: e.target.value
        });
    }

    updateCompanySlug(e) {
        if (this.state.slug == '' || this.state.slug == null) {
            modal.showInfo("Enter a listing public url.", "warning", "top", "center");
            return;
        }

        user.updateCompanySlug(this.state.slug, function(response) {
            modal.showInfo("Company listings slug updated. Use that link in your bio to display on your social media, allowing easier access to your listings.", "success", "top", "center");
        })
    }

    render(){
        const companySlug = this.state.slug;
        return (
            <div>
                {this.state.listings != null ? (
                <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <span class="main-page-header-title">Listings</span>
                            </div>
                            <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6">
                                <NavLink to={"/listing/new"}>
                                    <button type="button" id="add-listing" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                        Add Listing
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <br />
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="assignee" style={{color: "white"}}>Public URL<br/><small>https://app.leasey.co/listings/{companySlug}</small></label>
                                            <input type="text" value={companySlug} class="form-control tenant-info" name="title" placeholder="awesome-property-group" onChange={this.slugChange.bind(this)}/>
                                        </div>
                                        <button type="button" id="add-tenant" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.updateCompanySlug.bind(this)}>
                                            Update URL
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ListingCards sortID={0}/>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="sample-look">
                                    <div class="smartphone">
                                        { companySlug == null || companySlug == '' ? (
                                            <p style={{textAlign: 'center', padding: 10}}>Enter a company slug to get a live view of your listings.</p>
                                        ) : (
                                            <iframe src={"/listings/" + companySlug} width="100%" height="100%"/>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : (
                    <div>
                        <div style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Listings Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/listing/new"}>
                                            <button type="button" id="add-listing" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Listing
                                            </button>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/ListingTenant.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '560px'}}></div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Listings/Listings.jsx